import React from "react";
export default function Contact() {
  return (
    <h1 className=" text-center p-3 text-3xl font-semibold">
      Contact Us at thisisyashgarg@gmail.com
    </h1>
  );
}
